<template>
  <v-container>
    <v-row style="height: 100%;" justify="center" align="center">
      <v-col
        cols="12"
        :md="imagePath ? '7' : '5'"
        :class="!imagePath && `mt-16`"
        class="ColumnLayout__text"
      >
        <h1 class="ColumnLayout__header">
          <slot name="c1Header" />
        </h1>

        <div class="mt-7 ColumnLayout__body">
          <slot name="c1Body" /></div
      ></v-col>

      <v-col
        cols="12"
        md="5"
        v-if="imagePath"
        style="height: 100%"
        class="d-none d-md-block"
      >
        <v-row
          align="center"
          justify="center"
          class="pa-10"
          style="height: 100%;"
        >
          <!-- <div
            style="
              width: 100%;
              min-height: 300px;
              height: 100%;
              background-color: gray;
              opacity: 20%;
            "
          >
            {{ imagePath }}
          </div> -->
          <object
            width="100%"
            :data="require('@/assets/images/steps.svg')"
            type="image/svg+xml"
          ></object>
        </v-row>
      </v-col>

      <v-col
        cols="12"
        md="5"
        class="ml-md-auto mt-16 ColumnLayout__text"
        v-else
      >
        <h1 class="ColumnLayout__header">
          <slot name="c2Header" />
        </h1>

        <div class="mt-7 ColumnLayout__body">
          <slot name="c2Body" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ColumnLayout",

  props: {
    imagePath: {
      type: String,
      required: false,
    },
  },
};
</script>

<style>
.ColumnLayout__header {
  letter-spacing: -1.2px;
  line-height: 95%;
}

@media (max-width: 960px) {
  /* below laptop */
  .ColumnLayout__text {
    padding: 0 10px;
  }
}

@media (min-width: 960px) {
  /* laptop and above */
}
</style>
